import { Text } from '@innovationdepartment/proxima-ui';
import { formatCurrency } from 'utils';
import type { BrandProductCellRendererComponentProps } from '../types';

const BrandProductsAveragePrice = (
  props: BrandProductCellRendererComponentProps<'averagePriceUsd'>
) => {
  const { value } = props;

  return <Text variant="table1">{formatCurrency(+value)}</Text>;
};

export default BrandProductsAveragePrice;
